module.exports = __webpack_public_path__ + "static/media/icon_63.6564169d.svg";